import React, { useState } from "react";
import { Card, CardContent } from "./components/ui/card";
import { Button } from "./components/ui/button";
import { Input } from "./components/ui/input";

export default function SignatureGenerator() {
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [officePhone, setOfficePhone] = useState("");
  const [cellPhone, setCellPhone] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");

  const defaultAddress1 = "1510 W Canal Court, Suite 1000";
  const defaultAddress2 = "Littleton, CO 80120";
  const logoUrl = `${window.location.origin}/epoch-logo.png`; // Logo hosted in public folder

  const phoneSection = `
    ${officePhone ? `<strong>O:</strong> ${officePhone}<br>` : ""}
    ${cellPhone ? `<strong>C:</strong> ${cellPhone}<br>` : ""}
  `;

  const signatureRichText = `
    <div style="font-family: Helvetica, sans-serif; font-size: 10pt; color: black; background-color: transparent;">
      <strong>${name || "Your Name"}</strong><br>
      ${title || "Your Title"}<br>
      ${email || "your.email@epochconcepts.com"}<br>
      ${phoneSection}
      <br>
      ${address1 || defaultAddress1}<br>
      ${address2 || defaultAddress2}<br>
      <br>
      <img src="${logoUrl}" alt="Epoch Concepts Logo" style="width: 350px; height: auto; display: block;" />
    </div>
  `;

  const copyToClipboard = () => {
    const tempElement = document.createElement("div");
    tempElement.contentEditable = "true";
    tempElement.style.position = "absolute";
    tempElement.style.left = "-9999px";
    tempElement.style.backgroundColor = "transparent";
    tempElement.innerHTML = signatureRichText;
    document.body.appendChild(tempElement);
    const range = document.createRange();
    range.selectNodeContents(tempElement);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("copy");
    selection.removeAllRanges();
    document.body.removeChild(tempElement);
    alert("Signature copied to clipboard! You can now paste it directly into Outlook without formatting issues.");
  };

  return (
    <div className="flex flex-col items-center p-4">
      <Card className="w-full max-w-lg p-6 bg-white text-black">
        <CardContent>
          <h2 className="text-xl font-bold mb-4 text-black">Email Signature Generator</h2>
        
          {/* Inputs Section */}
          <div className="grid grid-cols-1 gap-3 mb-6">
            <Input placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} className="text-black" />
            <Input placeholder="Title" value={title} onChange={(e) => setTitle(e.target.value)} className="text-black" />
            <Input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="text-black" />
            <Input placeholder="Office Phone" value={officePhone} onChange={(e) => setOfficePhone(e.target.value)} className="text-black" />
            <Input placeholder="Cell Phone" value={cellPhone} onChange={(e) => setCellPhone(e.target.value)} className="text-black" />
            <Input placeholder="Address Line 1 (Leave blank for HQ)" value={address1} onChange={(e) => setAddress1(e.target.value)} className="text-black" />
            <Input placeholder="Address Line 2 (Leave blank for HQ)" value={address2} onChange={(e) => setAddress2(e.target.value)} className="text-black" />
          </div>

          {/* Visual Divider */}
          <div className="my-6">
            <hr className="border-t border-gray-300" />
          </div>

            {/* Signature Preview Section */}
          <div className="mt-6 border p-4 rounded bg-gray-100 text-black" dangerouslySetInnerHTML={{ __html: signatureRichText }}></div>

          <Button className="mt-6" onClick={copyToClipboard}>Copy Signature</Button>
        </CardContent>
      </Card>
    </div>
  );
}
